import React, { useState, useEffect, useRef } from 'react';
import { sendMessage, subscribeToTopic, setOnConnectCallback, disconnectClient } from './mqueue';
import * as d3 from 'd3';
import './App.css';
import Modal from 'react-bootstrap/Modal'; 
import Button from 'react-bootstrap/Button'; 


const defaultGraph = {
  "graph": {
    "nodes": [
      { "id": "#HashtagAI" },
      { "id": "@anjsimmo" },
      { "id": "#TheoremProving" },
      { "id": "#Chatbot" }
    ],
    "links": [
      { "source": "#HashtagAI", "target": "@anjsimmo", "relation": "#ceo" },
      { "source": "#HashtagAI", "target": "#TheoremProving", "relation": "#uses" },
      { "source": "#HashtagAI", "target": "#Chatbot", "relation": "#type" }
    ]
  }
};
const defaultGraphSerialised = JSON.stringify(defaultGraph, null, 2); 

const TOPIC = "prototype2";
const RESPONSE_TOPIC = `${crypto.randomUUID()}`; // unique queue for this client
//const RESPONSE_TOPIC = `response-queue`;

function App() {
  //console.log("graph is " + defaultGraphSerialised);
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState(defaultGraphSerialised); //useState('');
  const [status, setStatus] = useState('Init');
  const [timeOfLastRequest, setTimeOfLastRequest] = useState(Date.now());
  const [timeSinceLastRequest, setTimeSinceLastRequest] = useState(0);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const graphContainerRef = useRef(null);

  // for modal dialog. see https://react-bootstrap.netlify.app/docs/components/modal/
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  function countResponses() {
    const r = JSON.parse(response);
    const responses = new Set(r.entities || []).size;;
    const query = r.query || '';
    
    //return `Query:\n${query}\n\nResponses: ${responses}`
    if (!query) {
      return `Couldn't formalise the question. Please reword or try an example.`
    }
    return `Found ${responses} solutions`
  }

  function renderCountDown(milliseconds, status) {
    if (status.startsWith("!")) {
      return status.substring(1); // print warning, but strip ! symbol
    }

    if (status === "Init") {
      //return "Ask a question to get started";
      return "Ask a question to get started";
    }
    if (status === "Done") {
      return countResponses();
    }
    const t = Math.round(milliseconds / 1000);
    const COUNT_FROM = 20;
    if (t > COUNT_FROM) {
      return "Connection timeout. Please try one of the examples.";
    } else {
      return "Processing... " + (COUNT_FROM - t);
    }
  }

  const handleInputChange = (e) => {
    setPrompt(e.target.value);
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  }
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  }

  const handleFormSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    if (prompt.endsWith('.')) {
      handlePost();
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    sendMessage(TOPIC, prompt, RESPONSE_TOPIC, username);
    setStatus("Processing");
    setTimeOfLastRequest(Date.now());
    setTimeSinceLastRequest(0);
  };

  const handlePost = async () => {
    setStatus("!Sending...");
    
    setTimeout(() => {
      setStatus("!Post awaiting moderator approval before graph will be updated");
    }, 3000); // 3000 milliseconds = 3 seconds
  };


  useEffect(() => {
    // Set an interval to update timeSinceLastRequest every second
    const intervalId = setInterval(() => {
      const now = Date.now();
      const timeElapsed = now - timeOfLastRequest;
      setTimeSinceLastRequest(timeElapsed);
    }, 1000); // update every second

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [timeOfLastRequest]);

  useEffect(() => {
    // // Set the callback to subscribe after connection is established
    setOnConnectCallback(() => {
      console.log("subscribing")
      const subscription = subscribeToTopic(RESPONSE_TOPIC, (message) => {
        console.log('Received:', message);
        //setResponse(`Received: ${message}`);
        setResponse(message);
        setStatus("Done");
      });

      // Return cleanup function
      return () => {
        subscription.unsubscribe();
        disconnectClient();
      };
    });

    // disconnects prematurely
    // // Return cleanup function for the useEffect itself
    // return () => {
    //   disconnectClient();
    // };
  }, []);

  return (
    <div className="App container mt-5">
      {/* <div className="d-flex justify-content-between align-items-center"> */}
        {/* Placeholder for the application logo or name
        <div>
          <h1>hashtagpro</h1>
        </div> */}

        {/* Sign-in form */}
        {/* <div>
  <form className="d-flex align-items-center">
    <div className="col-3 pe-2">
      <input type="text" className="form-control" placeholder="Username" />
    </div>
    <div className="col-3 pe-2">
      <input type="password" className="form-control" placeholder="Password" />
    </div>
    <div className="col-6">
      <button type="submit" className="btn btn-outline-success w-100">Sign In Here</button>
    </div>
  </form>
      </div> */}

      {/* <div className='signin'>
      <a href="#">Sign in {password}</a>
      </div> */}
      <>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Sign in to enable #Pro features</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Sign in to enable pro access */}
          <div className="row mt-3">
            <div className="col">
              <input
                type="text"
                className="form-control"
                defaultValue={username}
                onChange={handleUsernameChange}
                placeholder="Username"
              />
            </div>
            <div className="col">
              <input
                type="text"
                className="form-control"
                defaultValue={password}
                onChange={handlePasswordChange}
                placeholder="Password"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Sign In
          </Button>
        </Modal.Footer>
      </Modal>
    </>
      <form onSubmit={handleFormSubmit}>
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            value={prompt}
            onChange={handleInputChange}
            placeholder="Name a chatbot that uses theorem proving"
          />
          <div className="input-group-append">
            <button className="btn btn-success" disabled={prompt.endsWith('.') || !prompt}>Ask</button>
          </div>
          <div className="input-group-append">
            <button className="btn btn-success" disabled={!prompt.endsWith('.')}>Post</button>
          </div>
          <Button variant="primary" onClick={handleShow}>
          #Pro
          </Button>
        </div>
      </form>
      <Graph response={response} containerRef={graphContainerRef} />
      <div>
        <pre>{renderCountDown(timeSinceLastRequest, status)}</pre>
      </div>
      <div id="examples">Examples:<br />
        Houses for rent under $1200/week<br />
        Houses for rent under $1200/week with at least 3 bathrooms<br />
        @anjsimmo has a spare room at 123 Burwood Hwy, rent is $200/week.<br />
        There's some offensive graffiti on Queens bridge.
      </div>
    </div>
  );
}

function convertString(input) {
  // Pattern to match numeric types including integers and decimals
  const numericPattern = /^"([\d\.]+)"\^\^<http:\/\/www\.w3\.org\/2001\/XMLSchema#(integer|decimal|double)>$/;
  if (numericPattern.test(input)) {
      return input.match(numericPattern)[1];
  }

  // Check if the input is a blank node
  const blankNodePattern = /^_:.*$/;
  if (blankNodePattern.test(input)) {
      return "";
  }

  // Check if the input is a URI with a hash part
  const uriPattern = /<http:\/\/.*#([^>]+)>$/;
  if (uriPattern.test(input)) {
      const lastPart = `#${input.match(uriPattern)[1]}`;
      console.log(lastPart);
      if (lastPart === "#sameAs") {
        return ""; // special case, don't display sameAs
      } else {
        return lastPart;
      }
  }

  // Default case, return the input as it is (handles normal strings)
  return input;
}


function Graph({ response, containerRef }) {
  useEffect(() => {
    if (!response) return; // Do not attempt to update graph if there is no data

    const data = JSON.parse(response); // Assume response is in a suitable JSON format
    console.log("Data is...");
    console.log(data);
    const { nodes, links } = data.graph;
    console.log("nodes is");
    console.log(nodes)

    // Clear the SVG before redrawing it
    const svg = d3.select(containerRef.current);
    svg.selectAll('*').remove();  // This removes all existing SVG elements

    const element = containerRef.current;
    const style = window.getComputedStyle(element);
    const width = parseFloat(style.width); // This is the computed width as a string, e.g., "500px"
    const height = parseFloat(style.height);
    
    console.log("Computed width:", width);


    svg.attr('width', width)
      .attr('height', height);

    const simulation = d3.forceSimulation(nodes)
      .force("link", d3.forceLink(links).id(d => d.id).distance(100))
      .force("charge", d3.forceManyBody().strength(-400))
      .force("center", d3.forceCenter(width/2, height/2));

    const link = svg.selectAll(".link")
      .data(links)
      .enter().append("line")
      .attr("class", "link")
      .style("stroke", "#999")
      .style("stroke-opacity", "0.6");

    const linkText = svg.selectAll(".link-label")
      .data(links)
      .enter().append("text")
      .attr("class", "link-label")
      .style("font-size", "10px")
      .text(d => convertString(d.relation));

    const node = svg.selectAll(".node")
      .data(nodes)
      .enter().append("circle")
      .attr("class", "node")
      .attr("r", 10)
      //.style("fill", "#69b3a2")
      .style("fill", "#000000")
      .call(d3.drag()
        .on("start", dragstarted)
        .on("drag", dragged)
        .on("end", dragended));

    const nodeText = svg.selectAll(".node-text")
      .data(nodes)
      .enter().append("text")
      .attr("class", "node-text")
      .style("font-size", "12px")
      .text(d => convertString(d.id))
      .attr("x", 12)
      .attr("y", ".35em");

    simulation.on("tick", () => {
      link.attr("x1", d => d.source.x)
          .attr("y1", d => d.source.y)
          .attr("x2", d => d.target.x)
          .attr("y2", d => d.target.y);

      linkText.attr("x", d => (d.source.x + d.target.x) / 2)
              .attr("y", d => (d.source.y + d.target.y) / 2);

      node.attr("cx", d => d.x)
          .attr("cy", d => d.y);

      nodeText.attr("transform", d => `translate(${d.x}, ${d.y})`);
    });

    function dragstarted(event, d) {
      if (!event.active) simulation.alphaTarget(0.3).restart();
      d.fx = d.x;
      d.fy = d.y;
    }

    function dragged(event, d) {
      d.fx = event.x;
      d.fy = event.y;
    }

    function dragended(event, d) {
      if (!event.active) simulation.alphaTarget(0);
      d.fx = null;
      d.fy = null;
    }

  }, [response]);

  return (
    <svg className="graphcontainer" ref={containerRef}></svg>
  );
}

export default App;
